module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-kansai-8-06f7e7ebdc319f3a464e68c84dcd6b58.png";